import { gql } from '@apollo/client';

const GET_PRACTICE_AREA_REPORT = gql`
  query GetPracticeAreaReport(
    $practiceAreaId: Int!
    $continuationToken: ContinuationTokenInput
    $limit: Int
  ) {
    practiceAreaReport(
      practiceAreaId: $practiceAreaId
      continuationToken: $continuationToken
      limit: $limit
    ) {
      PracticeReports {
        Practice {
          Name
          NumberWithinLevel
          PracticeGroup {
            Level
          }
        }
        QuarterlyData {
          Quarter {
            DisplayName
            Year
            QuarterNum
          }
          Average
        }
      }
      ContinuationToken {
        Offset
        QualifiedPractices
      }
    }
  }
`;

export default GET_PRACTICE_AREA_REPORT;
